import { TenantEntity } from '../TenantEntity'

export class UsCustomsClearanceCargo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    if (!serialNumber && serialNumber !== 0) {
      this._data.serialNumber = 1
    } else {
      this._data.serialNumber = serialNumber
    }
  }
  get customerProductName() {
    return this._data.customerProductName
  }
  set customerProductName(customerProductName) {
    this._data.customerProductName = customerProductName
  }
  get customsClearanceProductName() {
    return this._data.customsClearanceProductName
  }
  set customsClearanceProductName(customsClearanceProductName) {
    this._data.customsClearanceProductName = customsClearanceProductName
  }
  get packageNumber() {
    return this._data.packageNumber
  }
  set packageNumber(packageNumber) {
    this._data.packageNumber = packageNumber || 0
  }
  get packageType() {
    return this._data.packageType
  }
  set packageType(packageType) {
    this._data.packageType = packageType
  }
  get netWeight() {
    return this._data.netWeight
  }
  set netWeight(netWeight) {
    this._data.netWeight = netWeight || 0
  }
  get tariff() {
    return this._data.tariff
  }
  set tariff(tariff) {
    this._data.tariff = tariff || 0
  }
  get grossWeight() {
    return this._data.grossWeight
  }
  set grossWeight(grossWeight) {
    this._data.grossWeight = grossWeight || 0
  }
  get volume() {
    return this._data.volume
  }
  set volume(volume) {
    this._data.volume = volume || 0
  }
  get goodsNumber() {
    return this._data.goodsNumber
  }
  set goodsNumber(goodsNumber) {
    this._data.goodsNumber = goodsNumber || 0
  }
  get customsClearanceUnit() {
    return this._data.customsClearanceUnit
  }
  set customsClearanceUnit(customsClearanceUnit) {
    this._data.customsClearanceUnit = customsClearanceUnit
  }
  get unitWeight() {
    return this._data.unitWeight
  }
  set unitWeight(unitWeight) {
    this._data.unitWeight = unitWeight
  }
  get productPrice() {
    return this._data.productPrice
  }
  set productPrice(productPrice) {
    this._data.productPrice = productPrice || 0
  }
  get totalProductPrice() {
    return this._data.totalProductPrice
  }
  set totalProductPrice(totalProductPrice) {
    this._data.totalProductPrice = totalProductPrice || 0
  }
  get chinaAdditionalRate() {
    return this._data.chinaAdditionalRate
  }
  set chinaAdditionalRate(chinaAdditionalRate) {
    this._data.chinaAdditionalRate = chinaAdditionalRate || 0
  }
  get chinaAdditionalTaxRule() {
    return this._data.chinaAdditionalTaxRule
  }
  set chinaAdditionalTaxRule(chinaAdditionalTaxRule) {
    this._data.chinaAdditionalTaxRule = chinaAdditionalTaxRule
  }
  get chinaAdditionalTaxClause() {
    return this._data.chinaAdditionalTaxClause
  }
  set chinaAdditionalTaxClause(chinaAdditionalTaxClause) {
    this._data.chinaAdditionalTaxClause = chinaAdditionalTaxClause
  }
  get usCustomsClearanceUuid() {
    return this._data.usCustomsClearanceUuid
  }
  set usCustomsClearanceUuid(usCustomsClearanceUuid) {
    this._data.usCustomsClearanceUuid = usCustomsClearanceUuid
  }
  get relatedUsCustomsClearanceCargo() {
    return this._data.relatedUsCustomsClearance
  }
  set relatedUsCustomsClearanceCargo(relatedUsCustomsClearanceCargo) {
    this._data.relatedUsCustomsClearanceCargo = relatedUsCustomsClearanceCargo
  }
}
